export const ROUTES = {
  LOGIN: "/login",
  RESET_PASSWORD: "/reset-password",
  CHANGE_PASSWORD: "/change-password",
  HOME: "/",

  // === CLASSES ===
  CLASSES: {
    BASE: "/classes",
    ADD: "/add-classes",
    EDIT: "/edit-classes",
  },

  // === QUESTIONS ===
  QUESTIONS: {
    BASE: "/questions",
    COPY: "/copy-questions",
    SUBJECT: "/subject",
  },

  // === COURSES ===
  COURSES: {
    BASE: "/courses",
    ADD: "/add-course",
    EDIT: "/edit-course",
    MODULE: "/courses/module",
    MODULE_ADD_EDIT: "/courses/module/add-edit",
    LECTURES: "/courses/lectures",
    LECTURES_MODULE: "/courses/lectures/module",
    LECTURES_MODULE_ADD_EDIT: "/courses/lectures/module/add-edit",
    PURCHASE: "/courses/purchase",
    PURCHASE_EDIT: "/courses/purchase/edit",
    FAQ: "/course/faq",
    FAQ_ADD_EDIT: "/course/faq/add-edit",

  },

  // === WORKSHOPS ===
  WORKSHOPS: {
    BASE: "/workshop",
    WORKSHOP_ADD_EDIT: "/workshop/add-edit",
    REGISTER: "/workshop/register",
    REGISTER_EDIT: "/workshop/register/edit",
    LECTURES: "/workshop/lectures",
    LECTURES_ADD_EDIT: "/workshop/lectures/add-edit",
    TESTIMONIALS: "/workshop/testimonials",
    TESTIMONIALS_ADD_EDIT: "/workshop/testimonials/add-edit",
    FAQ: "/workshop/faq",
    FAQ_ADD_EDIT: "/workshop/faq/add-edit",
  },

  // === CONTEST ===
  CONTEST: {
    BASE: "/contest",
    ADD: "/add-contest",
    EDIT: "/edit-contest",
    TYPE: "/contest-type",
    LEADERBOARD: "/contest-leaderboard",
  },

  // === REPORTS ===
  REPORTS: {
    USER: "/user-report",
    QUESTION: "/question-report",
    RESULT: "/result-report",
  },

  // === EARNINGS ===
  EARNINGS: {
    CONTEST_WISE: "/contest-wise-earning",
    SUBJECT_WISE: "/subject-earning",
    SLOT_TIME: "/slot-time-earning",
    USER: "/user-earning",
    CLASSES: "/classes-earning",
  },

  // === USERS ===
  USERS: {
    BASE: "/students",
    DETAIL: "/user-detail",
    ADD: "/add-student",
    EDIT: "/edit-student",
    KYC: "/kyc",
  },

  // === WEBSITE CONTENT ===
  WEBSITE: {
    INTERFACE: "/interface",
    INTERFACE_ADD_EDIT: "/interface/add-edit",
    ABOUT_US: "/about-us",
    FEATURES: "/features",
    FEATURES_ADD_EDIT: "/features/add-edit",
    HOW_IT_WORKS: "/how-it-works",
    HOW_IT_WORKS_ADD_EDIT: "/how-it-works/add-edit",
    FAQ: "/landing-page/faq",
    FAQ_ADD_EDIT: "/landing-page/faq/add-edit",
    TRUSTED_BY: "/trusted-by",
    BANNER: "/banner",
    BLOG: "/blog",
    BLOG_ADD: "/add-blog",
    BLOG_EDIT: "/edit-blog",
    CONTACT_ENQUIRIES: "/contact-enquiries",
    CONTACT_ENQUIRIES_ADD: "/add-contact",
    CONTACT_ENQUIRIES_EDIT: "/edit-contact",
    TRUSTED_BY_ADD: "/add-trusted-by",
    TRUSTED_BY_EDIT: "/edit-trusted-by",

    // Legal documents
    PRIVACY_POLICY: "/privacy-policy",
    TERMS_CONDITION: "/terms-condition",
    LEGALITY: "/legality",
  },

  // === FINANCE ===
  FINANCE: {
    INCOME_EXPENSE: "/income-expense",
    WITHDRAWAL: "/withdrawal",
    WITHDRAWAL_REQUEST: "/withdrawal-request",
    REFUND_POLICY: "/refund-policy",
  },
  COUPON: {
    BASE: "/coupon",
    ADD_EDIT: "/coupon/add-edit"
  },

  YOUTUBE_VISUALS: "/youtube-visuals",
  SOCIAL_MEDIA_ENGAGE: "/social-media-engage",

  // === SETTINGS ===
  SETTINGS: "/setting",
  MOCK_TEST_DISCOUNT: "/mock-test-discount",
  FREE_MOCK_TEST: "/free-mock-test",
  PAYMENT_MESSAGE: "/payment-message",


  // === EXAM & GOAL ===
  EXAM_TYPE: "/exam-type",
  GOAL: "/goal",

  // === User Admin ===
  USER_ADMIN: {
    BASE: "/user-admin",
    ADD_EDIT: "/user/add-edit",

  },
};
